import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const ModalDialog = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    bsPrefix,
    className,
    contentClassName,
    centered,
    size,
    fullscreen,
    children,
    scrollable,
    ...props
  } = _ref;
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal');
  const dialogClass = "".concat(bsPrefix, "-dialog");
  const fullScreenClass = typeof fullscreen === 'string' ? "".concat(bsPrefix, "-fullscreen-").concat(fullscreen) : "".concat(bsPrefix, "-fullscreen");
  return /*#__PURE__*/_jsx("div", {
    ...props,
    ref: ref,
    className: classNames(dialogClass, className, size && "".concat(bsPrefix, "-").concat(size), centered && "".concat(dialogClass, "-centered"), scrollable && "".concat(dialogClass, "-scrollable"), fullscreen && fullScreenClass),
    children: /*#__PURE__*/_jsx("div", {
      className: classNames("".concat(bsPrefix, "-content"), contentClassName),
      children: children
    })
  });
});
ModalDialog.displayName = 'ModalDialog';
export default ModalDialog;